"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var utils_1 = __importDefault(require("@blaze-react/utils"));
var react_1 = __importStar(require("react"));
var Label_1 = __importDefault(require("./Label"));
var Checkbox = function (_a) {
    var checked = _a.checked, value = _a.value, disabled = _a.disabled, required = _a.required, label = _a.label, show = _a.show, name = _a.name, id = _a.id, onChange = _a.onChange, full = _a.full, _b = _a.utils, uniqueId = _b.uniqueId, classNames = _b.classNames, attrs = __rest(_a, ["checked", "value", "disabled", "required", "label", "show", "name", "id", "onChange", "full", "utils"]);
    var _c = react_1.useState(checked), isChecked = _c[0], setIsChecked = _c[1];
    var handleCheckboxChange = function (event) {
        onChange({
            event: event,
            value: {
                checked: !isChecked,
                disabled: disabled,
                id: id,
                label: label,
                name: name,
                required: required,
                show: show,
                value: value
            }
        });
        setIsChecked(!isChecked);
    };
    var checkboxClassName = classNames("form-field form-field--checkbox", {
        required: required
    });
    var labelClassName = classNames({
        "form-field--checkbox-full": full
    });
    var defaultId = id || uniqueId(name || value);
    var inputId = defaultId + "-checkbox";
    var wrapperId = defaultId + "-wrapper";
    return (react_1["default"].createElement("div", { key: wrapperId, className: checkboxClassName, role: "button" },
        react_1["default"].createElement("input", { "data-testid": attrs.testId, readOnly: true, type: "checkbox", className: "form-checkbox", value: value, disabled: disabled, checked: checked, required: required, id: inputId, name: name, onClick: handleCheckboxChange, "data-cy": attrs["data-cy"] }),
        react_1["default"].createElement("div", { onClick: handleCheckboxChange, className: labelClassName },
            react_1["default"].createElement(Label_1["default"], { defaultId: inputId, label: label }))));
};
exports["default"] = utils_1["default"](Checkbox);
